import React from 'react';
import PropTypes from 'prop-types';

function IconAlert({ className, style }) {
  return (
    <svg className={className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5278 4.9855L3.23232 17.1648C3.0819 17.4253 3.00231 17.7206 3.00147 18.0214C3.00063 18.3222 3.07856 18.618 3.22752 18.8793C3.37647 19.1406 3.59126 19.3584 3.85051 19.5109C4.10975 19.6635 4.40442 19.7455 4.7052 19.7488H19.2962C19.597 19.7455 19.8917 19.6635 20.1509 19.5109C20.4102 19.3584 20.6249 19.1406 20.7739 18.8793C20.9229 18.618 21.0008 18.3222 21 18.0214C20.9991 17.7206 20.9195 17.4253 20.7691 17.1648L13.4736 4.9855C13.32 4.73235 13.1038 4.52306 12.8458 4.37781C12.5879 4.23256 12.2968 4.15625 12.0007 4.15625C11.7046 4.15625 11.4136 4.23256 11.1556 4.37781C10.8976 4.52306 10.6814 4.73235 10.5278 4.9855V4.9855Z" stroke="#FF9800" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 9.41406V12.8594" stroke="#FF9800" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 16.3047H12.0086" stroke="#FF9800" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconAlert.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
}

export default IconAlert;
